/**
 * The admin shell deliberately keeps large, rarely-used views out of its
 * initial DOM. These are the only server-fetched HTML fragments that may be
 * parsed at runtime. Keeping the route list here makes the trust boundary
 * explicit and prevents a caller from turning a data/API response into DOM.
 */
export const TRUSTED_ADMIN_VIEW_FRAGMENT_PATHS = new Set([
  '/admin-views/ad-rules.html',
  '/admin-views/agent-ops.html',
  '/admin-views/ai-roles.html',
  '/admin-views/command-center.html',
  '/admin-views/cost-calculation.html',
  '/admin-views/feishu-sync-center.html',
  '/admin-views/groups.html',
  '/admin-views/identity.html',
  '/admin-views/image-manager.html',
  '/admin-views/jobs.html',
  '/admin-views/modules.html',
  '/admin-views/product-research-alert.html',
  '/admin-views/product-research-config.html',
  '/admin-views/product-research-logs.html',
  '/admin-views/provider-settings.html',
  '/admin-views/sif-login.html',
  '/admin-views/system-errors.html',
  '/admin-views/system-health.html',
  '/admin-views/video-manager.html',
]);

export function isTrustedAdminViewFragmentPath(path) {
  return TRUSTED_ADMIN_VIEW_FRAGMENT_PATHS.has(path);
}

export async function appendTrustedAdminViewFragment(host, path, failureMessage, {
  fetchImpl = fetch,
  documentRef = document,
} = {}) {
  if (!host) throw new Error('Admin lazy view host is unavailable');
  if (!isTrustedAdminViewFragmentPath(path)) {
    throw new Error(`Unregistered admin view fragment: ${String(path)}`);
  }

  const response = await fetchImpl(path, { credentials: 'same-origin' });
  if (!response.ok) throw new Error(failureMessage);

  const markup = await response.text();
  const range = documentRef.createRange();
  range.selectNodeContents(host);
  host.append(range.createContextualFragment(markup));
}
